module.exports = __webpack_public_path__ + "static/media/llanta-presion-red.7656ad22.svg";